export function isEqualMomentRange(range1:MomentRange|null, range2:MomentRange|null) {
    // console.log(JSON.stringify(range1))
    // console.log(JSON.stringify(range2))

    if (!range1 && !range2) {
        return true
    } else if (!range1 || !range2) {
        if ((range1 && !range2) || (!range1 && range2)) {
            return false
        } else {
            return true
        }
    } else {
        return  range1.start    && range2.start     && range1.start.isSame(range2.start) &&
                range1.end      && range2.end       && range1.end.isSame(range2.end)
    }
}